import request from '@services/request';

export interface CashinAccount {
  phone: string;
  name: string;
}

const getBasicUser = async (ci: string, complement: string) => {
  const result = await request.get('api/v1/corresponsal/cashin/getSender', { ci, complement });
  const { data } = result;
  return data;
};

const saveBasicUser = async (body: Record<string, unknown>) => {
  const result = await request.post('api/v1/corresponsal/cashin/saveSender', body);
  const { data } = result;
  return data;
};

const ValidSenderRequest = async (requestId: string) => {
  const result = await request.get('api/v1/corresponsal/cashin/validSender/request', { requestId });
  const { data } = result;
  return data;
};

const getAccountByPhone = async (cellphone: string) => {
  const result = await request.get('api/v1/corresponsal/cashin/account', { cellphone });
  const { data } = result;
  return data;
};

const completeCashin = async (body: Record<string, unknown>) => {
  const result = await request.post('api/v1/corresponsal/cashin/complete', body);
  const { data } = result;
  return data;
};

export type CashinProbeState = 'in_progress' | 'completed' | 'rejected' | 'unknown' | 'expired';

export interface CashinOutcomeError {
  code?: string;
  message?: string;
}

export interface CashinProbe {
  state?: CashinProbeState;
  transfer?: Record<string, unknown>[] | null;
  error?: CashinOutcomeError;
}

export interface CashinStatusResponse {
  errors?: CashinOutcomeError[];
  data?: CashinProbe;
}

export interface PendingCashin extends CashinProbe {
  request_id: string;
  cellphone: string;
  ci_sender: string;
  amount: string;
  account_owner?: string | null;
  created_at?: string;
}

export interface PendingCashinsResponse {
  errors?: CashinOutcomeError[];
  data?: PendingCashin[];
}

const getCashinStatus = async (requestId: string): Promise<CashinStatusResponse> => {
  const result = await request.get('api/v1/corresponsal/cashin/status', { request_id: requestId });
  const { data } = result;
  return data;
};

const getPendingCashins = async (): Promise<PendingCashinsResponse> => {
  const result = await request.get('api/v1/corresponsal/cashin/pending');
  const { data } = result;
  return data;
};

const acknowledgeCashin = async (requestId: string) => {
  const result = await request.post('api/v1/corresponsal/cashin/acknowledge', { request_id: requestId });
  const { data } = result;
  return data;
};

export {
  getBasicUser,
  saveBasicUser,
  getAccountByPhone,
  completeCashin,
  getCashinStatus,
  getPendingCashins,
  acknowledgeCashin,
  ValidSenderRequest,
};
